import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      'The following questions are to review how your progress has been so far. Please answer honestly and with as much detail as possible!',
    field: 'wl3months',
    type: 'info',
    required: true,
    answer: {}
  },
  {
    label:
      "Tell me how your last 3 months have been. Here are some things to cover: I've been losing weight (too fast not fast enough?), I have been making nutrition and exercise changes",
    type: 'info',
    field: 'wl3monthsSummery',
    placeholder: '',
    answer: {
      type: 'text',
      rows: 3,
      name: 'wl3monthsSummeryAns'
    }
  },
  {
    label: 'What is your current weight? (In Pounds)',
    type: 'info',
    field: 'wl3monthsWeightNow',
    placeholder: '',
    answer: {
      type: 'number',
      required: true,
      name: 'wl3monthsWeightNowAns'
    }
  },
  {
    label:
      'How much weight have you lost since starting the program? (In Pounds)',
    type: 'info',
    field: 'wl3monthsWeightLossFromStart',
    placeholder: '',
    answer: {
      type: 'number',
      required: true,
      name: 'wl3monthsWeightLossFromStartAns'
    }
  },
  {
    // 3
    label: 'Since starting the medication, have you experienced any of the following symptoms',
    field: 'wlFUSymptoms3M',
    type: 'select',
    required: false,
    answer: {
      type: 'multi_select',
      options: [
        { key: 'tingling', value: 'tingling in the hands and feet' },
        { key: 'hairloss', value: 'recent loss of hair' },
        { key: 'nails', value: 'brittle nails' },
        { key: 'coldHands', value: 'cold hands and feet' },
        { key: 'fatigue', value: 'fatigue' },
        { key: 'foggyBrain', value: 'foggy brain' },
        { key: 'paleskin', value: 'pale skin' },
        { key: 'shakiness', value: 'shakiness' },
        { key: 'muscleloss', value: 'muscle loss' },
        { key: 'cancersores', value: 'canker sores' },
        { key: 'swollengums', value: 'swollen gums or tongue' },
        { key: 'shortnessBreath', value: 'shortness of breath' },
        { key: 'heartPalp', value: 'heart palpitations' },
        { key: 'weakness', value: 'weakness' },
        { key: 'bonePain', value: 'bone pain' },
        { key: 'visionChanges', value: 'vision changes' },
        { key: 'poorwond', value: 'poor wound healing' },
        { key: 'dryskin', value: 'new or worsened dry skin' },
        { key: 'lessbowel', value: 'less than 3 bowel movements per week' },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  }, 

  {
    label: 'Any side effects or concerns? This can be acid reflux, nausea or vomiting, general tiredness, bloating or stomach pain.',
    type: 'info',
    field: 'wl3monthsConcerns',
    answer: {
      rows: 3,
      name: 'wl3monthsConcernsAns',
      type: 'text'
    }
  },
  {
    label: 'How much weight have you lost so far? (In Pounds)',
    type: 'info',
    field: 'wl3monthsWeightLossSoFar',
    placeholder: '',
    answer: {
      type: 'number',
      required: true,
      name: 'wl3monthsWeightLossSoFarAns'
    }
  },
  {
    label:
      'Please confirm the name and dose of Medication you are currently taking',
    type: 'info',
    field: 'wl3monthsNameAndDoseOfMedication',
    answer: {
      rows: 3,
      name: 'wl3monthsNameAndDoseOfMedicationAns',
      type: 'text'
    }
  },
  {
    label:
      'If you are comfortable with the current dose now, I can authorize another 3 months of the medication.',
    type: 'select',
    field: 'wl3monthsConsentForAnother3Months',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wl3monthsConsentForAnother3MonthsYes',
          value: 'Yes, I agree'
        },
        {
          key: 'wl3monthsConsentForAnother3MonthsNo',
          value: 'No, I want to discuss my dose'
        }
      ]
    }
  },
  {
    // 17
    label:
      'The following questions will give us a better understanding of how sustainable your results will likely be and how we can better help you achieve lasting results.',
    field: 'wlFU3Habbits',
    type: 'info',
    required: false,
    answer: {
      type: 'list',
      required: false,
      items: [
        {
          
          label: 'How many cups of liquids (e.g. water, juice, tea, coffee) do you get in a day? ',
          level: 'child',
          type: 'single_select',
          options: [
            { key: '1-2', value: '1-2' },
            { key: '3-4', value: '3-4' },
            { key: '5-6', value: '5-6' },
            { key: '7-8', value: '7-8' },
            { key: '9-10', value: '9-10' },
            { key: '10+', value: '10+' }
          ]
        },
        {
          label: 'On a usual day, how many times do you eat?',
          type: 'single_select',
          level: 'child',
          options: [
            { key: '1', value: '1' },
            { key: '2', value: '2' },
            { key: '3', value: '3' },
            { key: '4', value: '4' },
            { key: '5+', value: '5+' }

          ]
        },
        {
          label: 'On a usual day, how many meals or snacks include protein? (High protein foods include meat, seafood, fish legumes, beans, tempeh, tofu)',
          type: 'single_select',
          level: 'child',
          options: [
            { key: '1', value: '1' },
            { key: '2', value: '2' },
            { key: '3', value: '3' },
            { key: '4', value: '4' },
            { key: '5+', value: '5+' }

          ]
        },

        
      ]
    }
  }, //17
  
  {
    // 1
    label: 'Thinking about your diet in the past few weeks, which of these high protein foods foods do you most commonly eat?',
    subLabel: '(Select at least one, or all that apply.)',
    field: 'wLFU3Diet',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'meat',
          value: 'Meat',
          answer: {
            type: 'single_select',
            label: 'Which?',
            level: 'child',
            halfWidth: true,
            options: [
              { key: 'leanPoultry', value: 'Lean Poultry (e.g. chicken breast/turkey)' },
              { key: 'nonleanPoultry', value: 'Non-lean Poultry (e.g. chicken drumsticks, wings or thighs/ duck)' },
              { key: 'beef', value: 'Beef' },
              { key: 'pork', value: 'Pork' },
            ]
          }
        },
        {
          key: 'fish',
          value: 'Fish/seafood',
          answer: {
            type: 'single_select',
            label: 'which?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'shrimps', value: 'Shrimp/ pawns' },
              { key: 'crab', value: 'Crab/ Lobster' },
              { key: 'clam', value: 'Mollusks (e.g. clam, mussels)' },
              { key: 'salmon', value: 'Fatty Fish (e.g. salmon, rainbow trout, mackerel, sardines)' },
              { key: 'whitefish', value: 'White fish (e.g. haddock, cod, tilapia, halibut, snapper, canned tuna)' }
            ]
          }
        },
        {
          key: 'milk',
          value: 'Milk',
          answer: {
            type: 'single_select',
            label: 'which?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'skim', value: 'Skim milk' },
              { key: '%1', value: '1% milk' },
              { key: '%2', value: '2% milk' },
              { key: '%3.25', value: '3.25% milk' },
              { key: 'protien', value: 'High protein milk' }                  ]
          }
        },
        {
          key: 'dairy',
          value: 'Dairy Products',
          answer: {
            type: 'single_select',
            label: 'which?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'yougrt', value: 'Greek/Skyr Yogurt' },
              { key: 'cheese', value: 'Cheese' }                 ]
          }
        },
        {
          key: 'eggs',
          value: 'Eggs',
          answer: {
            type: 'single_select',
            label: 'which?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'eggs', value: 'Eggs' },
              { key: 'eggwhites', value: 'Egg whites' }                ]
          }
        },
        {
          key: 'vegetarianProducts',
          value: 'Vegetarian Products',
          answer: {
            type: 'single_select',
            label: 'which?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'extrafirmtofu', value: 'Extra firm tofu' },
              { key: 'tempeh', value: 'Tempeh' },
              { key: 'texturedVeg', value: 'Textured Vegetable Protein' },
              { key: 'edamameorLupini', value: 'Edamame or Lupini' }                ]
          }
        },
        {
          key: 'highProtien',
          value: 'High Protien',
          answer: {
            type: 'single_select',
            label: 'which?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'proteinShakes', value: 'Protien shakes' },
              { key: 'proteinBars', value: 'Protien bars' }                 ]
          }
        },
        { key: 'none', value: 'I eat none of these', uncheckOthers: true }

      ]
    }
  },

];

export default questionsModels;
